import React from "react";
import { IntlProvider, FormattedMessage, useIntl } from "react-intl";

import { FormGroup, FormField, Dropdown, Radio, Input, Checkbox } from "semantic-ui-react";
import { TimeFreeTextBox24 } from "react-lib/apps/common";

const CardORRequestUX = (props: any) => {
  return (
    <div id="CardORRequestUX-div-0" style={{ width: "100%", padding: "0.5rem" }}>
      <div
        id="CardORRequestUX-div-1"
        style={{ display: "flex", width: "100%", alignItems: "baseline" }}
      >
        <div
          id="CardORRequestUX-div-76"
          style={{
            fontSize: "1.25rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            minWidth: "max-content",
          }}
        >
          {props.languageUX === "en" ? "Operation Schedule" : "นัดหมายผ่าตัด"}
        </div>
        <div id="CardORRequestUX-div-77" style={{ marginLeft: "2rem" }}>
          {props.ORRequestMessage}
        </div>
        <div
          id="CardORRequestUX-div-80"
          style={{
            display: props.checkin_code ? "" : "none",
            marginLeft: "auto",
            minWidth: "max-content",
          }}
        >
          {}
          <label
            id="CardORRequestUX-label-81"
            style={{
              background: "#77e0eb",
              padding: "3px 10px",
              fontWeight: "bold",
              marginLeft: "1rem",
            }}
          >
            {`เลขที่ผ่าตัด: ${props.checkin_code || ""}`}
          </label>
        </div>
      </div>
      <div
        id="CardORRequestUX-div-2"
        style={{
          display: "grid",
          gridTemplateColumns: "74.5% 25.5%",
          columnGap: "10px",
          padding: "1rem 0",
        }}
      >
        <div
          className={`ui form ${props.isEncounterOPD ? "--override-disabled" : ""}`}
          id="CardORRequestUX-div-3"
          style={{ padding: "1.5rem 0.25rem 1rem 1rem", backgroundColor: "#D6ECF33B" }}
        >
          <FormGroup id="CardORRequestUX-FormGroup-5" inline={true}>
            <FormField
              id="CardORRequestUX-FormField-6"
              inline={true}
              style={{ minWidth: "max-content" }}
            >
              <label id="CardORRequestUX-label-10" style={{ margin: 0 }}>
                {props.languageUX === "en" ? "Type of Surgery" : "ประเภทผ่าตัด"}
              </label>
              <label id="CardORRequestUX-label-11" style={{ color: "red" }}>
                *
              </label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-7" inline={true} width={7}>
              <Dropdown
                disabled={props.config?.allowedEdit || props.type === "EL"}
                fluid={true}
                id="CardORRequestUX-Dropdown-12"
                name="type"
                onChange={props.onChangeValue}
                options={props.orTypeOptions || []}
                selection={true}
                style={{ width: "100%" }}
                value={props.type || ""}
              ></Dropdown>
            </FormField>
            <FormField
              id="CardORRequestUX-FormField-8"
              inline={true}
              style={{ minWidth: "max-content" }}
            >
              <label id="CardORRequestUX-label-13" style={{ margin: 0 }}>
                {props.languageUX === "en" ? "Type of Clinic" : "ประเภทคลินิก"}
              </label>
              <label id="CardORRequestUX-label-14" style={{ color: "red" }}>
                *
              </label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-9" inline={true} width={5}>
              <Dropdown
                disabled={props.config?.allowedEdit}
                fluid={true}
                id="CardORRequestUX-Dropdown-15"
                name="clinic_type"
                onChange={props.onChangeValue}
                options={props.orClinicTypeOptions}
                selection={true}
                style={{ width: "100%" }}
                value={props.clinicType || ""}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup id="CardORRequestUX-FormGroup-16" inline={true}>
            <FormField
              id="CardORRequestUX-FormField-18"
              inline={true}
              style={{ minWidth: "max-content" }}
            >
              <label id="CardORRequestUX-label-23" style={{ margin: 0 }}>
                Case
              </label>
              <label id="CardORRequestUX-label-24" style={{ color: "red" }}>
                *
              </label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-19">
              <Radio
                checked={props.isOpdCase || false}
                disabled={props.config?.allowedEdit || props.encounterType === "IPD"}
                id="CardORRequestUX-Radio-25"
                label="OPD"
                name="case.is_opd_case"
                onChange={props.onChangeValue}
              ></Radio>
            </FormField>
            <FormField id="CardORRequestUX-FormField-20">
              <Radio
                checked={props.isOneDayCase || false}
                disabled={props.config?.allowedEdit || props.encounterType === "IPD"}
                id="CardORRequestUX-Radio-26"
                label="One day"
                name="case.is_one_day_case"
                onChange={props.onChangeValue}
              ></Radio>
            </FormField>
            <FormField id="CardORRequestUX-FormField-21">
              <Radio
                checked={props.isIpdCase || false}
                disabled={props.config?.allowedEdit || false}
                id="CardORRequestUX-Radio-27"
                label="IPD"
                name="case.is_ipd_case"
                onChange={props.onChangeValue}
              ></Radio>
            </FormField>
            <FormField id="CardORRequestUX-FormField-22" inline={true} width={5}>
              <Dropdown
                clearable={true}
                disabled={!props.isIpdCase || props.config?.allowedEdit || false}
                fluid={true}
                id="CardORRequestUX-Dropdown-28"
                name="case.ipd_case"
                onChange={props.onChangeValue}
                options={props.admitCaseOptions}
                selection={true}
                style={{ width: "100%" }}
                value={props.ipdCase || ""}
              ></Dropdown>
              <Input
                id="CardORRequestUX-Input-99"
                readOnly={true}
                style={{ width: "100%", display: props.encounterType === "IPD" ? "" : "none" }}
                type="text"
                value={props.admitText}
              ></Input>
            </FormField>
            <FormField id="CardORRequestUX-FormField-29" inline={true} width={3}>
              <label id="CardORRequestUX-label-30" style={{ minWidth: "max-content" }}>
                {props.languageUX === "en" ? "Inpatient" : "นอน รพ."}
              </label>
              <Input
                disabled={props.config.disabledIpdCase || props.config?.allowedEdit || false}
                id="CardORRequestUX-Input-32"
                name="case.ipd_day"
                onChange={props.onChangeValue}
                type="number"
                value={props.ipdDay || ""}
              ></Input>
              <label id="CardORRequestUX-label-31" style={{ marginLeft: "10px" }}>
                {props.languageUX === "en" ? "Day" : "วัน"}
              </label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-85" inline={true} width={4}>
              <Checkbox
                checked={props.isRequestIcu || false}
                disabled={props.config.disabledIpdCase || props.config?.allowedEdit || false}
                id="CardORRequestUX-Checkbox-89"
                label="Request ICU"
                name="case.is_request_icu"
                onChange={props.onChangeValue}
                style={{ minWidth: "max-content" }}
              ></Checkbox>
              <Input
                disabled={props.config.disabledRequestIcu || props.config?.allowedEdit || false}
                fluid={true}
                id="CardORRequestUX-Input-87"
                name="case.icu_day"
                onChange={props.onChangeValue}
                style={{ width: "100%" }}
                type="number"
                value={props.icuDay || ""}
              ></Input>
              <label
                id="CardORRequestUX-label-88"
                style={{ fontWeight: "normal", marginLeft: "0.5rem" }}
              >
                {props.languageUX === "en" ? "Day" : "วัน"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORRequestUX-FormGroup-17"
            inline={true}
            style={{ display: "none" }}
            widths={10}
          >
            <FormField id="CardORRequestUX-FormField-33">
              <label id="CardORRequestUX-label-40">วันที่นัด Admit</label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-35" inline={true} width={5}>
              <Checkbox
                checked={props.isAppAdmit || false}
                disabled={props.isEncounterOPD || props.config?.allowedEdit || false}
                id="CardORRequestUX-Checkbox-84"
                label="นัดหมาย"
                name="case.is_app_admit"
                onChange={props.onChangeValue}
                style={{ minWidth: "max-content" }}
              ></Checkbox>
              <div id="CardORRequestUX-div-42" style={{ width: "100%" }}>
                {props.DateTextBoxApp}
              </div>
            </FormField>
            <FormField id="CardORRequestUX-FormField-37" inline={true} width={5}>
              <label
                id="CardORRequestUX-label-82"
                style={{ width: "100%", maxWidth: "max-content" }}
              >
                เลือก Admit Order
              </label>
              <Dropdown
                clearable={true}
                disabled={props.isEncounterOPD || props.config?.allowedEdit || false}
                fluid={true}
                id="CardORRequestUX-Dropdown-44"
                name="admit_order"
                onChange={props.onChangeValue}
                options={props.admitOrderOptions || []}
                search={true}
                selection={true}
                style={{ width: "100%" }}
                value={props.admitOrder || ""}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup id="CardORRequestUX-FormGroup-90" inline={true} widths={10}>
            <FormField id="CardORRequestUX-FormField-91" inline={true} width={2}>
              <label id="CardORRequestUX-label-94">
                {props.languageUX === "en" ? "Date of Admission" : "วันที่นัด Admit"}
              </label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-92" inline={true} width={5}>
              <div id="CardORRequestUX-div-95" style={{ width: "100%" }}>
                {props.DateTextBoxApp}
              </div>
            </FormField>
            <FormField id="CardORRequestUX-FormField-93" inline={true} width={2}>
              <label id="CardORRequestUX-label-96">
                {props.languageUX === "en" ? "Admit Time" : "เวลา Admit"}
              </label>
            </FormField>
            <FormField id="CardORRequestUX-FormField-97" inline={true} width={5}>
              <TimeFreeTextBox24
                className="time-custom-react-picker"
                disabled={props.config.disabledIpdCase || props.config?.allowedEdit || false}
                onChange={props.onChangeORTime}
                value={props.ORRequestSequence?.case?.app_admit_time || ""}
              ></TimeFreeTextBox24>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardORRequestUX-div-4"
          style={{ padding: "1.5rem 0.25rem 1rem 1rem", backgroundColor: "#D6ECF33B" }}
        >
          <div className="ui form" id="CardORRequestUX-div-48">
            <FormGroup id="CardORRequestUX-FormGroup-49" inline={true}>
              <FormField id="CardORRequestUX-FormField-52" inline={true} width={7}>
                <Checkbox
                  checked={props.isMedBlock || false}
                  id="CardORRequestUX-Checkbox-58"
                  label="Med- block"
                  name="is_med_block"
                  onChange={props.onChangeValue}
                  style={{ minWidth: "max-content" }}
                ></Checkbox>
              </FormField>
              <FormField id="CardORRequestUX-FormField-53" inline={true} width={9}>
                <div id="CardORRequestUX-div-61" style={{ width: "100%" }}>
                  {props.DateTextBoxMed}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup id="CardORRequestUX-FormGroup-50" inline={true}>
              <FormField id="CardORRequestUX-FormField-54" inline={true} width={7}>
                <Checkbox
                  checked={props.isAnesthesia || false}
                  id="CardORRequestUX-Checkbox-59"
                  label={props.languageUX === "en" ? "Anesthesiologist" : "วิสัญญี"}
                  name="is_anesthesia"
                  onChange={props.onChangeValue}
                ></Checkbox>
              </FormField>
              <FormField id="CardORRequestUX-FormField-55" inline={true} width={9}>
                <div id="CardORRequestUX-div-62" style={{ width: "100%" }}>
                  {props.DateTextBoxAnes}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup id="CardORRequestUX-FormGroup-51" inline={true}>
              <FormField id="CardORRequestUX-FormField-56" inline={true} width={7}>
                <Checkbox
                  checked={props.isOther || false}
                  id="CardORRequestUX-Checkbox-60"
                  name="is_other"
                  onChange={props.onChangeValue}
                ></Checkbox>
                <Input
                  disabled={props.config.disabledOther || false}
                  id="CardORRequestUX-Input-67"
                  name="other"
                  onChange={props.onChangeValue}
                  placeholder={props.languageUX === "en" ? "Other " : "อื่นๆ"}
                  value={props.other || ""}
                ></Input>
              </FormField>
              <FormField id="CardORRequestUX-FormField-57" inline={true} width={9}>
                <div id="CardORRequestUX-div-63" style={{ width: "100%" }}>
                  {props.DateTextBoxOther}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
      <div id="CardORRequestUX-div-64" style={{ width: "100%" }}>
        {props.CardSurgeryTeam}
      </div>
      <div id="CardORRequestUX-div-65" style={{ width: "100%" }}>
        {props.CardAnesthesiaTeam}
      </div>
      <div id="CardORRequestUX-div-66" style={{ width: "100%" }}>
        {props.CardORDetail}
      </div>
      <div
        id="CardORRequestUX-div-68"
        style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}
      >
        <div id="CardORRequestUX-div-79">{props.ClearElement}</div>
        <div
          id="CardORRequestUX-div-78"
          style={{ marginRight: props.config?.allowedPrint ? "1rem" : "" }}
        >
          {props.PrintElement}
        </div>
        <div
          id="CardORRequestUX-div-73"
          style={{ marginRight: props.config?.allowedConfirm ? "1rem" : "" }}
        >
          {props.ConfirmElement}
        </div>
        <div
          id="CardORRequestUX-div-74"
          style={{ marginRight: props.config?.allowedCancelConfirm ? "1rem" : "" }}
        >
          {props.CancelConfirmElement}
        </div>
        <div
          id="CardORRequestUX-div-75"
          style={{ marginRight: props.config?.allowedCancel ? "1rem" : "" }}
        >
          {props.CancelElement}
        </div>
        <div id="CardORRequestUX-div-71" style={{ marginRight: "1rem" }}>
          {props.SaveElement}
        </div>
      </div>
    </div>
  );
};

export default CardORRequestUX;

export const screenPropsDefault = { language: "TH" };

/* Date Time : Thu Sep 03 2026 17:21:23 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"0.5rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"100%\", alignItems: \"baseline\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"74.5% 25.5%\", columnGap: \"10px\", padding: \"1rem 0\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "`ui form ${props.isEncounterOPD?\"--override-disabled\":\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1.5rem 0.25rem 1rem 1rem\", backgroundColor: \"#D6ECF33B\",}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1.5rem 0.25rem 1rem 1rem\", backgroundColor: \"#D6ECF33B\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทผ่าตัด",
          "valueEN": "Type of Surgery"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-10"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-11"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Dropdown",
      "parent": 7,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config?.allowedEdit || props.type === \"EL\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Dropdown-12"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.orTypeOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.type || \"\""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทคลินิก",
          "valueEN": "Type of Clinic"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-13"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-14"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Dropdown",
      "parent": 9,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config?.allowedEdit"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Dropdown-15"
        },
        "name": {
          "type": "value",
          "value": "clinic_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.orClinicTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.clinicType || \"\""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        },
        "widths": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "Case"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Radio",
      "parent": 19,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isOpdCase || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.allowedEdit || props.encounterType === \"IPD\""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Radio-25"
        },
        "label": {
          "type": "value",
          "value": "OPD"
        },
        "name": {
          "type": "value",
          "value": "case.is_opd_case"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Radio",
      "parent": 20,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isOneDayCase || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.allowedEdit || props.encounterType === \"IPD\""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Radio-26"
        },
        "label": {
          "type": "value",
          "value": "One day"
        },
        "name": {
          "type": "value",
          "value": "case.is_one_day_case"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Radio",
      "parent": 21,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isIpdCase || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.allowedEdit || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Radio-27"
        },
        "label": {
          "type": "value",
          "value": "IPD"
        },
        "name": {
          "type": "value",
          "value": "case.is_ipd_case"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.isIpdCase || props.config?.allowedEdit || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Dropdown-28"
        },
        "name": {
          "type": "value",
          "value": "case.ipd_case"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.admitCaseOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.ipdCase || \"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "นอน รพ.",
          "valueEN": "Inpatient"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-30"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน",
          "valueEN": "Day"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-31"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Input",
      "parent": 29,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config.disabledIpdCase || props.config?.allowedEdit || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Input-32"
        },
        "name": {
          "type": "value",
          "value": "case.ipd_day"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.ipdDay || \"\""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัด Admit"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-40"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxApp"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Dropdown",
      "parent": 37,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "defaultValue": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.isEncounterOPD || props.config?.allowedEdit || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Dropdown-44"
        },
        "name": {
          "type": "value",
          "value": "admit_order"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.admitOrderOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.admitOrder || \"\""
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Checkbox",
      "parent": 52,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isMedBlock || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Checkbox-58"
        },
        "label": {
          "type": "value",
          "value": "Med- block"
        },
        "name": {
          "type": "value",
          "value": "is_med_block"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Checkbox",
      "parent": 54,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isAnesthesia || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Checkbox-59"
        },
        "label": {
          "type": "value",
          "value": "วิสัญญี",
          "valueEN": "Anesthesiologist"
        },
        "name": {
          "type": "value",
          "value": "is_anesthesia"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Checkbox",
      "parent": 56,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isOther || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Checkbox-60"
        },
        "label": {
          "type": "value",
          "value": ""
        },
        "name": {
          "type": "value",
          "value": "is_other"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxMed"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxAnes"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxOther"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CardSurgeryTeam"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CardAnesthesiaTeam"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CardORDetail"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "Input",
      "parent": 56,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config.disabledOther || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Input-67"
        },
        "name": {
          "type": "value",
          "value": "other"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "placeholder": {
          "type": "value",
          "value": "อื่นๆ",
          "valueEN": "Other "
        },
        "value": {
          "type": "code",
          "value": "props.other || \"\""
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SaveElement"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1rem\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ConfirmElement"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: props.config?.allowedConfirm ? \"1rem\" : \"\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CancelConfirmElement"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: props.config?.allowedCancelConfirm ? \"1rem\" : \"\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CancelElement"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: props.config?.allowedCancel ? \"1rem\" : \"\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "นัดหมายผ่าตัด",
          "valueEN": "Operation Schedule"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.25rem\", fontWeight: \"bold\", marginBottom: \"1rem\", minWidth: \"max-content\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ORRequestMessage"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"2rem\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PrintElement"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: props.config?.allowedPrint ? \"1rem\" : \"\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClearElement"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-79"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.checkin_code ? \"\" : \"none\", marginLeft: \"auto\", minWidth: \"max-content\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "`เลขที่ผ่าตัด: ${props.checkin_code || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#77e0eb\", padding: \"3px 10px\", fontWeight: \"bold\", marginLeft: \"1rem\" }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก Admit Order"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-82"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Checkbox",
      "parent": 35,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isAppAdmit || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.isEncounterOPD || props.config?.allowedEdit || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Checkbox-84"
        },
        "label": {
          "type": "value",
          "value": "นัดหมาย"
        },
        "name": {
          "type": "value",
          "value": "case.is_app_admit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Input",
      "parent": 85,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config.disabledRequestIcu || props.config?.allowedEdit || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Input-87"
        },
        "name": {
          "type": "value",
          "value": "case.icu_day"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.icuDay || \"\""
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน",
          "valueEN": "Day"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-88"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", marginLeft: \"0.5rem\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Checkbox",
      "parent": 85,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isRequestIcu || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.config.disabledIpdCase || props.config?.allowedEdit || false"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Checkbox-89"
        },
        "label": {
          "type": "value",
          "value": "Request ICU"
        },
        "name": {
          "type": "value",
          "value": "case.is_request_icu"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormGroup-90"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormField",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "label",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัด Admit",
          "valueEN": "Date of Admission"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-94"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxApp"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา Admit",
          "valueEN": "Admit Time"
        },
        "id": {
          "type": "value",
          "value": "CardORRequestUX-label-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 98,
      "name": "TimeFreeTextBox24",
      "parent": 97,
      "props": {
        "className": {
          "type": "value",
          "value": "time-custom-react-picker"
        },
        "disabled": {
          "type": "code",
          "value": "props.config.disabledIpdCase || props.config?.allowedEdit || false"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeORTime"
        },
        "value": {
          "type": "code",
          "value": "props.ORRequestSequence?.case?.app_admit_time || \"\""
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Input",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRequestUX-Input-99"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: props.encounterType === \"IPD\" ? \"\" : \"none\"}"
        },
        "type": {
          "type": "value",
          "value": "text"
        },
        "value": {
          "type": "code",
          "value": "props.admitText"
        }
      },
      "seq": 99,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardORRequestUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
